module.exports = __webpack_public_path__ + "img/stories.e588d677.svg";